import get from 'lodash/get';
import filter from 'lodash/filter';
import isUndefined from 'lodash/isUndefined';

import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';
import { removeArrayItem } from '../../utils/arrayModify';

const supportedActions = [
  'SET_CIRCLE',
  'CLEAR',
  'REMOVE_FAMILY_CIRCLE_ITEM',
  'REMOVE_INVITATION',
  'ADD_PENDING_ITEM',
];

export const consts = createConsts(
  'board',
  'circleOfCare',
  ...supportedActions,
);
export const actions = createActions(consts);

// init
const initialState = {
  familyCircle: [],
  careProviders: [],
  pendingFamilyMembers: [],
};

const removeInvitation = (state, { invitationId }) => {
  const list = get(state, 'pendingFamilyMembers');
  const pendingFamilyMembers = removeArrayItem(
    list,
    'invitationId',
    invitationId,
  );

  return { ...state, pendingFamilyMembers };
};

const addPendingItem = (state, item) => {
  const list = [
    ...get(state, 'pendingFamilyMembers'),
    {...item, pending: true },
  ];

  const guardians = list.filter(el => el.careRole === "guardian");
  const proxys = list.filter(el => el.careRole === "proxy");
  const parents = list.filter(el => el.careRole === "parent");
  const caregivers = list.filter(el => el.careRole === "caregiver");
  const rest = list.filter(el => isUndefined(el.careRole));

  return {
    ...state,
    pendingFamilyMembers: [
      ...guardians,
      ...proxys,
      ...parents,
      ...caregivers,
      ...rest,
    ],
  };
};

// reducer
const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.REMOVE_FAMILY_CIRCLE_ITEM:
      return {
        ...state,
        familyCircle: filter(
          get(state, 'familyCircle', []),
          item => item.id !== payload,
        ),
      };
    case consts.REMOVE_INVITATION:
      return removeInvitation(state, payload);
    case consts.ADD_PENDING_ITEM:
      return addPendingItem(state, payload);
    case consts.SET_CIRCLE:
      return payload;
    case consts.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/board/circleOfCare.js